import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "../util/AppContext";
import signOut from "../API/authorization";
import { useNavigate } from "react-router-dom";

function SignOutPage() {
	const [appState] = useContext(AppContext);
	const [pageProperties] = useState(appState.config?.SignOff);
	const [isLoading, setIsLoading] = useState(true);
	const navigate = useNavigate();

	function getDialogTitle() {
		return [pageProperties.Title.Value];
	};

	function getBodyContents() {
		let messageElemets = '';
        pageProperties.Body.forEach(element => {
            messageElemets += element.Value;
        });

		return messageElemets;
	}

    useEffect(() => {
		setIsLoading(true);
		logout();
    }, []);

	async function logout() {
		await signOut(appState.isAlternateLogin)
		.then(() => {    
			sessionStorage.clear(); 
		})
		.catch((err) => {
			navigate('/SignOutErrorPage');
		})
		.finally(() => {
			setIsLoading(false);
		});
	}

	return (
		<>
		{!isLoading && <div className="container-xl">
			<div className="row justify-content-center">
				<div className="col-12 col-sm-10 col-md-6">
					<div className="alert alert-success mt-8" role="alert">
						<div className="alert-icon"></div>
						<div className="alert-content">
							<h4 className="h5 alert-heading" dangerouslySetInnerHTML={{ __html: getDialogTitle() }}></h4>
							<p dangerouslySetInnerHTML={{ __html: getBodyContents() }}></p>
						</div>
					</div>
				</div>
			</div>
		</div>}		
		</>
	)
}

export default SignOutPage